<template>
    <v-card>
        <v-card-text class="px-5 py-5">
            <div
                class="d-flex align-center font-weight-bold font-size-16 danger--text"
            >
                <v-icon class="mr-1 danger--text"
                    >mdi mdi-delete-outline</v-icon
                >
                {{ title }}
            </div>

            <div class="mt-2 font-size-14">
                {{ subtitle }}
            </div>

            <div class="mt-5">
                <v-row class="d-flex align-center d-flex">
                    <v-col>
                        <v-btn
                            color="#df4f4f"
                            outlined
                            depressed
                            block
                            height="40px"
                            style="border: 1.6px solid"
                            class="font-weight-bold"
                            @click="$emit('close')"
                        >
                            Batal
                        </v-btn>
                    </v-col>

                    <v-col>
                        <v-btn
                            color="#df4f4f"
                            dark
                            depressed
                            block
                            height="40px"
                            class="font-weight-bold"
                            @click="$emit('confirm')"
                        >
                            Oke
                        </v-btn>
                    </v-col>
                </v-row>
            </div>
        </v-card-text>
    </v-card>
</template>

<script>
export default {
    props: {
        title: { type: String, default: null },
        subtitle: { type: String, default: null },
    },
    name: "DialogConfirm",
};
</script>



// WEBPACK FOOTER //
// DialogConfirm.vue?3176e46c